import { Spin as n } from "antd";
import t from "react";
const r = (e) => {
  const { showFullParent: l = !1, absolute: o = !1, ...a } = e, s = {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      style: {
        height: l ? "100%" : void 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...o ? s : {}
      }
    },
    /* @__PURE__ */ t.createElement(n, { size: "large", ...a })
  );
}, f = r;
export {
  f as default
};
